import React, { FC, useState } from 'react';
import { Box, IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import useStyles from './styles';

const ITEM_HEIGHT = 48;

interface MessageProps {
  onRespond?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
}

const ChatMenu: FC<MessageProps> = (props) => {
  const { onRespond, onDelete, disabled } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box className={classes.wrapper}>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        disabled={disabled}
        onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}>
        {!!onRespond && (
          <MenuItem
            key="respond"
            onClick={() => {
              onRespond();
              handleClose();
            }}>
            Répondre
          </MenuItem>
        )}
        {!!onDelete && (
          <MenuItem
            key="delete"
            onClick={() => {
              onDelete();
              handleClose();
            }}>
            Supprimer
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
};

export default ChatMenu;
